import http from '@/utils/http';
import config from '@/config/user.env';

const findCurrUserUrl = '/api-auth/userInfo/getLogIn';
const getResuorceBySysAuthUrl = `/mframework/sys/authority/sysAuthResource/getResuorceBySysAuth?appId=${config.appId}`;
const switchLangUrl = '/mframework/sys/org/savePersonConf';
const getAllTenantsUrl = '/api-auth/tenant/getUserAllTenants';
const getApplication = '/api-auth/getUserApplications';
const logoutAPI = '/api-auth/ssoLogout';
const getAllResourcesUrl = '/api-auth/getAllResources';

/**
 * 登录后查找当前用户信息
 */
export function findCurrUser() {
    return http({
        url: findCurrUserUrl,
        method: 'get'
    });
}

/**
 * 登录后获取当前租户信息
 */
export function getUserAllTenants(params) {
    return http({
        url: getAllTenantsUrl,
        method: 'get',
        params: params
    });
}

/**
 * 退出登录
 */
export function Logout() {
    return http({
        url: logoutAPI,
        method: 'get'
    });
}

/**
 * 设置租户
 */
export function setTenant(data) {
    return http({
        url: `/api-auth/setTenant/${data.tenantCode}`,
        method: 'put'
    });
}

/**
 * 获取应用
 */
export function getUserApplications(params) {
    return http({
        url: getApplication,
        method: 'get',
        params: params
    });
}

/**
 * 获取菜单
 */
export function getResuorceBySysAuth() {
    return http({
        url: getResuorceBySysAuthUrl,
        method: 'get'
    });
}

/**
 * 语言切换
 */
export function switchLang(langType) {
    // debugger;
    return http({
        url: switchLangUrl,
        method: 'post',
        data: {
            langType
        }
    });
}

/**
 * 获取菜单
 */
export const getAllResources = (params) => {
    return http({
        url: getAllResourcesUrl,
        method: 'get',
        params: params
    });
};

/**
 * 获取承运商
 */
export const querySupplierInFoBySupplierCode = (params) => {
    return http({
        url: `/api-srm-web/supplier/querySupplierInfoByUserCode/${params}`,
        method: 'get'
    });
};

/**
 * 获取供应商信息
 */
export const getSupplierContactsInfos = data => {
    return http({
        url: `/api-srm-web/supplier/supplierContactsInfos`,
        method: 'post',
        data
    });
};

/**
 * 获取供应商证件预警信息
 */
export const getSupplierQualifications = (param) => {
    return http({
        url: `/api-srm-web/supplier/strongControlWarnings/getWarningInfo`,
        method: 'get',
        params: {
            tenantCode: param
        }
    });
};

/**
 * 获取itsm登录token
 */
export const getItsmLogin = (params) => {
    return http({
        url: `/api-srm/public/api/itsm/login`,
        method: 'get',
        params
    });
};

/**
 * 判断是否跳转至EL系统
 */
export const getBlackWhiteSwitch = (params) => {
    return http({
        url: `/api-srm-web/supplier/supplierLspBlackWhiteSwitch`,
        method: 'get',
    });
};
